import { ResultsClient } from '../common/ResultsClient';
import { HTTP_METHOD } from '../common/consts';

class Idel2ResultsClient extends ResultsClient {
    static BASE_URL = '/idel2-api/results/v1/results';

    /**
     * Get http client config for get results operation
     * @param {Object{}} params get request parameters
     * @param {Array<String>} params{}.studentUids - non-empty list of student ids to get results for
     * @param {Integer} params{}.schoolYear - school year to get results for, optional
     * @param {String} params{}.gradeLevel - grade results are associated with
     * @param {String} params{}.period - results period
     * @param {Boolean} params{}.includeInvalidated - whether invalidated results should be returned
     * @param {Array<String>} params{}.language - results' language
     * @param {String} [classID=undefined] - If set, API response would contain students results that were created in specified class.
     * @returns {Object}
     */
    static getResultsRequestConfig({
        studentUids,
        schoolYear,
        gradeLevel,
        period,
        includeInvalidated,
        language,
        classId,
    } = {}) {
        return {
            url: this.BASE_URL,
            method: HTTP_METHOD.GET,
            params: {
                studentUids: studentUids.join(','),
                schoolYear,
                gradeLevel,
                period,
                includeInvalidated,
                language: language && language.join(','),
                classId,
            },
        };
    }

    /**
     * Send request to get result on server from provided data
     * @param {Array<String>} studentUids - non-empty list of student ids to get results for
     * @param {Integer} schoolYear - school year to get results for, optional
     * @param {Boolean} [includeInvalidated=false] - whether to include invalidated results
     * @param {Array<String>} [language=[]] - results' language, e.g. ['eng', 'spa']
     * @param {String} [classID=undefined] - If set, API response would contain students results that were created in specified class.
     */
    async getResults(studentUids, schoolYear, includeInvalidated = false, classId) {
        const baseUrl = this.constructor.BASE_URL;
        return this.httpClient.request(
            this.constructor.getResultsRequestConfig({
                baseUrl,
                studentUids,
                schoolYear,
                includeInvalidated,
                language: [],
                classId,
            }),
        );
    }
}

export default Idel2ResultsClient;
